import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { DEFAULT_SUPPORTED_LANGUAGE } from '@/modules/common/constants/languages';

import type { WatchType } from '@/modules/common/types';
import { TranslationMapType } from '@/modules/common/types/i18n';

import en from '../../i18n/en.json';

export type I18nState = {
  translateLanguage: WatchType['language'];
  translations: TranslationMapType;
};

const initialState: I18nState = {
  translateLanguage: DEFAULT_SUPPORTED_LANGUAGE,
  translations: { ...en },
};

export const slice = createSlice({
  name: 'i18n',
  initialState,
  reducers: {
    setTranslationsAction(state, action: PayloadAction<I18nState>) {
      state.translateLanguage = action.payload.translateLanguage;
      state.translations = action.payload.translations;
    },
  },
});

export const { setTranslationsAction } = slice.actions;
